document.addEventListener("DOMContentLoaded", function () {
  const defaultColorDivs = document.querySelectorAll(".custom-variant-color");
  const defaultColor = defaultColorDivs[0]?.getAttribute("data-color") || "";

  window.updateColorDisplay = function (element) {
    const color = element.getAttribute("data-color");
    defaultColorDivs.forEach((div) => {
      div.textContent = color;
    });
  };

  window.resetColorDisplay = function () {
    defaultColorDivs.forEach((div) => {
      div.textContent = defaultColor;
    });
  };
  document.querySelectorAll(".show-hidden-colors").forEach((button) => {
    button.addEventListener("click", function () {
      const parent = this.closest(".custom-image-color-picker-wrapper");
      if (parent) {
        parent.classList.toggle("show");
      }
    });
  });
});
